<template>
  <section style="overflow-x: hidden !important">
    <!--img class="screenOne" src="@/assets/landingScreen1.svg" /> 
    <img class="screenTwo" src="@/assets/landingScreen2.svg" /> 
    <div class="landingTopColour"></div-->
    <!--img class="bigBack" src="@/assets/background.png" /-->
    <!--img class="iPhone" src="@/assets/iPhonePic.png" /-->
    <!--img class="computer" src="@/assets/computerPic.png" /-->
    <div class="landNavbar" id="fixed">
      <!-- brand design -->
      <div class="flexNav" id="landingLogo">
        <a href="#" class="flexLogo">
          <img
            src="@/assets/landingLogo.svg"
            width="237"
            height="49"
            alt="main page logo"
          />
        </a>
      </div>

      <!-- profile design -->
      <div class="flexNav" id="navigation">
        <a class="landingButton" href="#contact">Contact Us</a>
        <!--:to="{
            name: 'Contact',
          }"-->
        <router-link
          class="landingButton"
          :to="{
            name: 'EmailLandingPage',
          }"
          >Schools</router-link
        >
        <router-link
          class="landingButton"
          :to="{
            name: 'Login',
          }"
          >Login</router-link
        >

        <router-link
          class="landingButton"
          :to="{
            name: 'Signup',
          }"
          >Sign up</router-link
        >
        <div class="hamburgerMenu">
          <input id="hamburgerBox" type="checkbox" />

          <span class="hamburgerLayer" id="firstLayer"></span>
          <span class="hamburgerLayer" id="secondLayer"></span>
          <span class="hamburgerLayer" id="thirdLayer"></span>

          <ul id="smallMenu">
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'EmailLandingPage',
              }"
              >Schools</router-link
            >
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Login',
              }"
              >Login</router-link
            >

            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Signup',
              }"
              >Sign up</router-link
            >

            <div id="contact" class="navbarBottom">
              <div class="totalContact contactLeft">
                <a
                  href="https://apps.apple.com/ca/app/courselnk/id1545799969"
                  class="appstore"
                  target="_blank"
                ></a>
                <a
                  href="https://facebook.com/courselnk"
                  class="facebook"
                  target="_blank"
                ></a>

                <a
                  href="https://instagram.com/courselnk"
                  class="instagram"
                  target="_blank"
                ></a>

                <a
                  href="https://linkedin.com/company/71220107"
                  class="linkedin"
                  target="_blank"
                ></a>
                <a
                  href="mailto:support@courselnk.com"
                  class="email"
                  target="_blank"
                ></a>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div class="firstBox" id="header">
      <div class="firstText">
        <p class="hugeTitle white">
          Connect With
          <span style="color: #ffffff !important">Classmates.</span>
        </p>
        <p
          style="margin-top: 25px; margin-left: 5px; margin-bottom: 25px"
          class="bigText white"
        >
          Easily find pre-made group chats for all your classes, faculties and
          extracurriculars.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonLanding"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk!</router-link
          >
          <router-link
            class="blowUp"
            :to="{
              name: 'Ambassadors',
            }"
            >Join the team!</router-link
          >
        </div>
      </div>
      <!--div class="constructedImg">
        <img class="firstImg" src="@/assets/landingScreenDesignBack.svg" />
        <div class="vidOneDiv">
          <img class="vidOne hoverFeature" src="@/assets/landingvidOne.svg" />
        </div>
        <div class="chatOneDiv">
          <img class="chatOne hoverFeature" src="@/assets/landingChatOne.svg" />
        </div>
        <div class="chatTwoDiv">
          <img class="chatTwo hoverFeature" src="@/assets/landingChatTwo.svg" />
        </div>
        <div class="imgOneDiv">
          <img class="imgOne hoverFeature" src="@/assets/landingImgOne.svg" />
        </div>
        <div class="chatThreeDiv">
          <img
            class="chatThree hoverFeature"
            src="@/assets/landingChatThree.svg"
          />
        </div>
        <div class="profileOneDiv">
          <img
            class="profileOne hoverFeature"
            src="@/assets/landingProfileOne.svg"
          />
        </div>
        <div class="profileTwoDiv">
          <img
            class="profileTwo hoverFeature"
            src="@/assets/landingProfileTwo.svg"
          />
        </div>
        <div class="profileThreeDiv">
          <img
            class="profileThree hoverFeature"
            src="@/assets/landingProfileThree.svg"
          />
        </div>
      </div-->
      <div class="landingRight">
        <img class="landingHeaderImg" src="@/assets/landingHeader.png" />
      </div>
    </div>

    <!-- JOIN CHAT-->
    <div class="secondBox">
      <div class="boxTwoLeft">
        <img class="landingTagPost" src="@/assets/landingCourses.png" />
      </div>
      <div class="BoxTwoContent">
        <p class="hugeTitle">Join any</p>
        <p class="hugeTitle" style="color: #11cdc4">group chat.</p>
        <p class="bigText marginTop">
          Easily join any course chats, faculty chats, and any other university
          group you might need.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
      </div>
    </div>

    <!-- REACT CHAT-->
    <div class="thirdBox">
      <div class="BoxTwoContent">
        <p class="hugeTitle">Discuss and</p>
        <p class="hugeTitle" style="color: #11cdc4">collaborate.</p>
        <p class="bigText marginTop">
          Add tags and reactions to any post that you love and need and find
          them later through filters.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
      </div>
      <div class="boxThreeLeft">
        <img class="landingTagPost" src="@/assets/landingReact.png" />
      </div>
    </div>

    <!-- CALENDAR -->
    <div class="secondBox">
      <div class="boxTwoLeft">
        <img class="landingCalIcon" src="@/assets/landingCalendar.png" />
      </div>
      <div class="BoxTwoContent">
        <p class="hugeTitle">Never miss</p>
        <p class="hugeTitle" style="color: #11cdc4">a deadline.</p>
        <p class="bigText marginTop">
          Stay on top of your deadlines with community course calendars.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
        <p class="marginTop">*coming soon</p>
      </div>
    </div>

    <!-- REVIEW-->
    <div class="thirdBox">
      <div class="BoxTwoContent">
        <p class="hugeTitle">Review profs</p>
        <p class="hugeTitle" style="color: #11cdc4">and courses.</p>
        <p class="bigText marginTop">
          Effortlessly leave and check out reviews for your profs and courses.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
        <p class="marginTop">*coming soon</p>
      </div>
      <div class="boxThreeLeft">
        <img class="landingTagPost" src="@/assets/landingReview.png" />
      </div>
    </div>

    <!-- DOCUMENT UPLOAD -->
    <div class="secondBox">
      <div class="boxTwoLeft">
        <img class="landingCalIcon" src="@/assets/landingUpload.png" />
      </div>
      <div class="BoxTwoContent">
        <p class="hugeTitle">Share your</p>
        <p class="hugeTitle" style="color: #11cdc4">documents.</p>
        <p class="bigText marginTop">
          See all your class's information and notes in one place at all times.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
        <p class="marginTop">*coming soon</p>
      </div>
    </div>

    <!-- ON COMPUTER -->
    <div class="thirdBox">
      <div class="BoxTwoContent">
        <p class="hugeTitle">Start</p>
        <p class="hugeTitle" style="color: #11cdc4">right now.</p>
        <p class="bigText marginTop">
          CourseLnk is available on browser for easier document uploads and
          tags.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
      </div>
      <div class="boxThreeLeft">
        <img class="boxThreeLeft" src="@/assets/computerScreen.png" />
      </div>
    </div>

    <div class="secondBox">
      <div class="boxTwoLeft">
        <img class="boxTwoLeft" src="@/assets/phoneScreen.png" />
      </div>
      <div class="BoxTwoContent">
        <p class="hugeTitle">Download</p>
        <p class="hugeTitle" style="color: #11cdc4">our app.</p>
        <p class="bigText marginTop">
          Find CourseLnk on the App Store or the Google Play Store*. Download
          now.
        </p>
        <div class="buttonRow">
          <router-link
            class="joinButtonSmall marginTop"
            :to="{
              name: 'Signup',
            }"
            >Join CourseLnk</router-link
          >
        </div>
        <p class="marginTop">*coming soon</p>
      </div>
    </div>

    <div id="contact" class="bottomLanding">
      <div class="totalContact">
        <a
          href="https://apps.apple.com/ca/app/courselnk/id1545799969"
          class="appstore"
          target="_blank"
        ></a>
        <a
          href="https://facebook.com/courselnk"
          class="facebook"
          target="_blank"
        ></a>

        <a
          href="https://instagram.com/courselnk"
          class="instagram"
          target="_blank"
        ></a>

        <a
          href="https://linkedin.com/company/71220107"
          class="linkedin"
          target="_blank"
        ></a>
        <a
          href="mailto:support@courselnk.com"
          class="email"
          target="_blank"
        ></a>
      </div>
      <div class="bottomLandingText marginTop">
        <p class="smallText white">© CourseLnk 2021.</p>
        <router-link
          :to="{ name: 'Terms' }"
          target="_blank"
          class="smallText white"
        >
          Terms and Conditions
        </router-link>
        <router-link
          :to="{ name: 'Privacy' }"
          target="_blank"
          class="smallText white"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    isElemVisible(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top + 100; // 200 = buffer
      var elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },

    isEnd(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top; // 200 = buffer
      var elemBottom = rect.bottom - 100;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },

    handleScroll() {
      var fadeInElements = [];
      fadeInElements = Array.from(
        document.getElementsByClassName("BoxTwoContent")
      );
      for (var i = 0; i < fadeInElements.length; i++) {
        var elem = fadeInElements[i];
        if (this.isElemVisible(elem)) {
          elem.style.opacity = "1";
          elem.style.transform = "scale(1)";
          fadeInElements.splice(i, 1); // only allow it to run once
        }
      }

      var two = document.getElementById("phoneTwo");
      var three = document.getElementById("phoneThree");
      var four = document.getElementById("phoneFour");
      var screen = document.getElementById("compScreen");
      var header = document.getElementById("header");
      if (!this.isEnd(header)) {
        document.getElementById("fixed").style.backgroundColor = "#0ca69e";
        document.getElementById("landingLogo").style.opacity = "1";
      } else {
        document.getElementById("fixed").style.backgroundColor = "#0ca69e00";
        if (pageYOffset > 0) {
          document.getElementById("landingLogo").style.opacity = "0.2";
        } else {
          document.getElementById("landingLogo").style.opacity = "1";
        }
      }

      //var containerHeight = a.getBoundingClientRect().height
      if (this.isElemVisible(two)) {
        two.style.transform = "rotate(-12deg) translate(-50px, -0px)";
        three.style.transform = "rotate(12deg) translate(50px, -0px)";
        four.style.transform = "rotate(36deg) translate(150px, -30px)";
      }
      if (this.isElemVisible(screen)) {
        screen.style.opacity = "1";
      }
    },
  },
};
</script>

<style scoped src="@/styles/views/Landingpage.css"></style>
